
export const errorMessages = {
    canNotContinue: "You cannot continue.",
    informationMissing: " There seems to be some information missing.",
    completeClinicalTemplate: "Complete the clinical template to continue.",
    oopsError: "Oops! A system error has occurred.",
    changeSearchOptions: "By changing your search option you will clear the results. Are you sure you want to change your search option?",
    requiredValueMissing: "Required value missing",
    invalidFormat: "Invalid Format.",
    troubleRetrievingResults: "We're having trouble retrieving your search results.",
    tryAgainLater: "Please try again later.",
    updateYourCriteria: "Please update your search criteria.",
    notContractedProvider: "Based on our records, you are not a contracted provider with the health plan for which you requested HomeBridge Portal access. Please contact the health plan to update your profile data on file. If you believe you have received this message in error, please contact us",
    invalidRequest: "Invalid Request",
    invalidRequestDate: "This request is not managed by CareCentrix. Please reach out to the health plan for further instructions.",
    noAttachmentErrorTitle: "The attachment detail you selected is not uploaded to this request.",
    noAttachmentErrorDescription: "Select 'Upload Document' to complete the document upload process."
};